import { motion } from "framer-motion";

const reveal = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
};

const Nosotros = () => (
  <section id="nosotros" data-testid="nosotros-section" className="bg-[#F6F7F5] text-[#151A1F] py-24 sm:py-32 border-t border-[#151A1F]/10">
    <div className="mx-auto max-w-7xl px-6 sm:px-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        <motion.div {...reveal} className="lg:col-span-5 relative">
          <div className="relative overflow-hidden rounded-sm border border-[#151A1F]/10">
            <img
              src="/fotos/diego-ingeniero.webp"
              alt="Diego Antelo, ingeniero agropecuario responsable técnico de Fumiga, en un campo de girasol"
              className="w-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="absolute -top-px -right-px w-10 h-10 border-t-2 border-r-2 border-[#046A38]" aria-hidden="true" />
          <div className="absolute -bottom-px -left-px w-10 h-10 border-b-2 border-l-2 border-[#046A38]" aria-hidden="true" />
          <p className="mt-4 font-mono-tech text-[10px] uppercase tracking-[0.25em] text-[#6B7280]">
            Diego Antelo · Ingeniero Agropecuario
          </p>
        </motion.div>

        <div className="lg:col-span-7">
          <motion.p {...reveal} className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-[#046A38]">
            Nosotros · Perfil del ingeniero
          </motion.p>
          <motion.h2
            {...reveal}
            transition={{ ...reveal.transition, delay: 0.1 }}
            className="font-display font-bold tracking-tight leading-[1.08] text-2xl sm:text-4xl lg:text-5xl mt-6"
          >
            Más que volar drones, mi compromiso es{" "}
            <span className="text-[#046A38]">hacer rendir cada hectárea de tu cultivo.</span>
          </motion.h2>
          <motion.div
            {...reveal}
            transition={{ ...reveal.transition, delay: 0.15 }}
            className="mt-8 space-y-5 text-base sm:text-lg text-[#151A1F]/75 leading-relaxed max-w-2xl"
          >
            <p>
              Hola, soy Diego Antelo, Ingeniero Agropecuario de profesión, emprendedor
              y productor de ocupación. Entiendo perfectamente lo que significa invertir
              tiempo, trabajo y capital en la tierra. Sé que para un productor agrícola,
              cada litro de insumo cuenta y que las plagas o enfermedades no esperan.
            </p>
            <p>
              Decidí especializarme en la aplicación agrícola de precisión con drones no
              por moda tecnológica, sino porque vi la oportunidad real de devolverle
              rentabilidad y eficiencia al agricultor.
            </p>
            <p>
              Fumiga nace en Santa Cruz de la Sierra para una sola cosa: aplicar con
              drones donde el productor lo necesita, cuando lo necesita. Sin
              intermediarios, sin letra chica y con la cara puesta.
            </p>
          </motion.div>

          <motion.div
            {...reveal}
            transition={{ ...reveal.transition, delay: 0.2 }}
            className="mt-10 max-w-2xl border-l-2 border-[#046A38] pl-6"
            data-testid="nosotros-compromiso"
          >
            <p className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-[#046A38]">
              Mi compromiso en campo es
            </p>
            <p className="mt-3 font-display font-bold text-xl sm:text-2xl leading-snug">
              Una marca que se sostiene sobre la garantía de una experiencia positiva
              y un resultado real.
            </p>
            <p className="mt-4 text-base text-[#151A1F]/75 leading-relaxed">
              Con criterio técnico y respaldo productivo, garantizo una aplicación
              homogénea que penetra hasta el envés de la hoja sin pisar una sola
              planta, cuidando tu rendimiento por hectárea y reduciendo el desperdicio
              de insumos químicos.
            </p>
          </motion.div>

          <motion.div
            {...reveal}
            transition={{ ...reveal.transition, delay: 0.25 }}
            className="mt-10 flex flex-wrap gap-8 border-t border-[#151A1F]/10 pt-8"
          >
            <div>
              <p className="font-display font-bold text-2xl tabular">1 : 1</p>
              <p className="text-sm text-[#151A1F]/60 mt-1">Trato directo con el ingeniero</p>
            </div>
            <div>
              <p className="font-display font-bold text-2xl tabular">65</p>
              <p className="text-sm text-[#151A1F]/60 mt-1">Localidades con cobertura</p>
            </div>
            <div>
              <p className="font-display font-bold text-2xl">SCZ</p>
              <p className="text-sm text-[#151A1F]/60 mt-1">Base en Santa Cruz de la Sierra</p>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  </section>
);

export default Nosotros;
